import * as React from 'react';
import styles from './index.less';
import type { PopoverProps, TooltipPlacement } from 'antd';
import { Popover } from 'antd';

interface FPopoverPureProps extends PopoverProps {
  open?: boolean;
  content: React.ReactNode;
  children: React.ReactNode;
  placement?: TooltipPlacement;
}

function FPopoverPure({ open, content, children, placement }: FPopoverPureProps) {
  return (<Popover
    className={styles.className}
    overlayClassName={styles.overlayClassName}
    openClassName={styles.openClassName}
    open={open}
    title={null}
    styles={{ body: { padding: 0 }, root: { padding: 0 } }}
    style={{ padding: 0 }}
    content={content}
    placement={placement}
  >{children}</Popover>);
}

export default FPopoverPure;
